/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CalculationRequest } from '../models';
// @ts-ignore
import type { CalculationResponse } from '../models';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { EcotransitBatchPostResponse } from '../models';
// @ts-ignore
import type { EcotransitBatchRequest } from '../models';
// @ts-ignore
import type { EcotransitBatchStatusResponse } from '../models';
// @ts-ignore
import type { EcotransitCalculationRequest } from '../models';
// @ts-ignore
import type { EcotransitCalculationResponse } from '../models';
/**
 * CalculationServiceLogisticsApi - axios parameter creator
 */
export const CalculationServiceLogisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate CO2 emissions for transport
         * @param {EcotransitBatchRequest} ecotransitBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecotransitBatchCalculation: async (ecotransitBatchRequest: EcotransitBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecotransitBatchRequest' is not null or undefined
            assertParamExists('ecotransitBatchCalculation', 'ecotransitBatchRequest', ecotransitBatchRequest)
            const localVarPath = `/calculation/v1/calculate/logistics/ecotransit/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ecotransitBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get batch calculation status
         * @param {string} batchId Batch ID
         * @param {string} [cursor] Marks the last item returned on the previous page
         * @param {string} [limit] Determines number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecotransitBatchStatus: async (batchId: string, cursor?: string, limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('ecotransitBatchStatus', 'batchId', batchId)
            const localVarPath = `/calculation/v1/calculate/logistics/ecotransit/batch/{batchId}`
                .replace(`{${"batchId"}}`, encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions for logistics using EcoTransIT
         * @param {EcotransitCalculationRequest} ecotransitCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecotransitCalculation: async (ecotransitCalculationRequest: EcotransitCalculationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecotransitCalculationRequest' is not null or undefined
            assertParamExists('ecotransitCalculation', 'ecotransitCalculationRequest', ecotransitCalculationRequest)
            const localVarPath = `/calculation/v1/calculate/logistics/ecotransit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ecotransitCalculationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate CO2 emissions for transport
         * @param {CalculationRequest} calculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportTotalEmissions: async (calculationRequest: CalculationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculationRequest' is not null or undefined
            assertParamExists('transportTotalEmissions', 'calculationRequest', calculationRequest)
            const localVarPath = `/calculation/v1/calculate/transportTotalEmissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceLogisticsApi - functional programming interface
 */
export const CalculationServiceLogisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceLogisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate CO2 emissions for transport
         * @param {EcotransitBatchRequest} ecotransitBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecotransitBatchCalculation(ecotransitBatchRequest: EcotransitBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcotransitBatchPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecotransitBatchCalculation(ecotransitBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceLogisticsApi.ecotransitBatchCalculation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get batch calculation status
         * @param {string} batchId Batch ID
         * @param {string} [cursor] Marks the last item returned on the previous page
         * @param {string} [limit] Determines number of items to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecotransitBatchStatus(batchId: string, cursor?: string, limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcotransitBatchStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecotransitBatchStatus(batchId, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceLogisticsApi.ecotransitBatchStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions for logistics using EcoTransIT
         * @param {EcotransitCalculationRequest} ecotransitCalculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ecotransitCalculation(ecotransitCalculationRequest: EcotransitCalculationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EcotransitCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ecotransitCalculation(ecotransitCalculationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceLogisticsApi.ecotransitCalculation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate CO2 emissions for transport
         * @param {CalculationRequest} calculationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transportTotalEmissions(calculationRequest: CalculationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transportTotalEmissions(calculationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceLogisticsApi.transportTotalEmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceLogisticsApi - factory interface
 */
export const CalculationServiceLogisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceLogisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate CO2 emissions for transport
         * @param {CalculationServiceLogisticsApiEcotransitBatchCalculationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecotransitBatchCalculation(requestParameters: CalculationServiceLogisticsApiEcotransitBatchCalculationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EcotransitBatchPostResponse> {
            return localVarFp.ecotransitBatchCalculation(requestParameters.ecotransitBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get batch calculation status
         * @param {CalculationServiceLogisticsApiEcotransitBatchStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecotransitBatchStatus(requestParameters: CalculationServiceLogisticsApiEcotransitBatchStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<EcotransitBatchStatusResponse> {
            return localVarFp.ecotransitBatchStatus(requestParameters.batchId, requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions for logistics using EcoTransIT
         * @param {CalculationServiceLogisticsApiEcotransitCalculationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ecotransitCalculation(requestParameters: CalculationServiceLogisticsApiEcotransitCalculationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EcotransitCalculationResponse> {
            return localVarFp.ecotransitCalculation(requestParameters.ecotransitCalculationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate CO2 emissions for transport
         * @param {CalculationServiceLogisticsApiTransportTotalEmissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transportTotalEmissions(requestParameters: CalculationServiceLogisticsApiTransportTotalEmissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalculationResponse> {
            return localVarFp.transportTotalEmissions(requestParameters.calculationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for ecotransitBatchCalculation operation in CalculationServiceLogisticsApi.
 */
export interface CalculationServiceLogisticsApiEcotransitBatchCalculationRequest {
    readonly ecotransitBatchRequest: EcotransitBatchRequest
}

/**
 * Request parameters for ecotransitBatchStatus operation in CalculationServiceLogisticsApi.
 */
export interface CalculationServiceLogisticsApiEcotransitBatchStatusRequest {
    /**
     * Batch ID
     */
    readonly batchId: string

    /**
     * Marks the last item returned on the previous page
     */
    readonly cursor?: string

    /**
     * Determines number of items to return per page
     */
    readonly limit?: string
}

/**
 * Request parameters for ecotransitCalculation operation in CalculationServiceLogisticsApi.
 */
export interface CalculationServiceLogisticsApiEcotransitCalculationRequest {
    readonly ecotransitCalculationRequest: EcotransitCalculationRequest
}

/**
 * Request parameters for transportTotalEmissions operation in CalculationServiceLogisticsApi.
 */
export interface CalculationServiceLogisticsApiTransportTotalEmissionsRequest {
    readonly calculationRequest: CalculationRequest
}

/**
 * CalculationServiceLogisticsApi - object-oriented interface
 */
export class CalculationServiceLogisticsApi extends BaseAPI {
    /**
     * 
     * @summary Calculate CO2 emissions for transport
     * @param {CalculationServiceLogisticsApiEcotransitBatchCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ecotransitBatchCalculation(requestParameters: CalculationServiceLogisticsApiEcotransitBatchCalculationRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceLogisticsApiFp(this.configuration).ecotransitBatchCalculation(requestParameters.ecotransitBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get batch calculation status
     * @param {CalculationServiceLogisticsApiEcotransitBatchStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ecotransitBatchStatus(requestParameters: CalculationServiceLogisticsApiEcotransitBatchStatusRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceLogisticsApiFp(this.configuration).ecotransitBatchStatus(requestParameters.batchId, requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions for logistics using EcoTransIT
     * @param {CalculationServiceLogisticsApiEcotransitCalculationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public ecotransitCalculation(requestParameters: CalculationServiceLogisticsApiEcotransitCalculationRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceLogisticsApiFp(this.configuration).ecotransitCalculation(requestParameters.ecotransitCalculationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate CO2 emissions for transport
     * @param {CalculationServiceLogisticsApiTransportTotalEmissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public transportTotalEmissions(requestParameters: CalculationServiceLogisticsApiTransportTotalEmissionsRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceLogisticsApiFp(this.configuration).transportTotalEmissions(requestParameters.calculationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

